import { render, staticRenderFns } from "./OtherServiceFormModal.vue?vue&type=template&id=ef3c3548&"
import script from "./OtherServiceFormModal.ts?vue&type=script&lang=js&"
export * from "./OtherServiceFormModal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports